import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '../../../redux/hooks';
import { getAppAnalytics } from '../../../redux/viewApp/appAnalytics/selectors';

export const ProviderDetails = () => {
  const appAnalytics = useAppSelector(getAppAnalytics);
  return (
    <Box width="100%" borderRadius="16px" mt="30px" bgColor="#F7F9FB" boxShadow="2px">
      <VStack align="flex-start" padding={6} w="100%" h="100%" spacing="30px">
        <VStack align="flex-start" w="100%" spacing={4}>
          <Text
            color="black"
            className="small-font"
            style={{ fontWeight: 650 }}
            whiteSpace="pre-line"
            fontWeight="bold"
            fontFamily="inter"
          >
            Provider ID Details
          </Text>
          {appAnalytics?.appDetail?.httpProvider?.length &&
            appAnalytics?.appDetail?.httpProvider?.map((provider, index) => (
              <HStack w="100%" justifyContent="flex-start" key={index}>
                <Text
                  color="gray"
                  w="30%"
                  className="x-small-font"
                  whiteSpace="pre-line"
                  fontFamily="inter"
                >
                  {provider.httpProviderId}
                </Text>
                <Text
                  color="black"
                  w="70%"
                  className="x-small-font"
                  noOfLines={1}
                  whiteSpace="pre-line"
                  fontFamily="inter"
                >
                  {provider.name}
                </Text>
              </HStack>
            ))}
        </VStack>
      </VStack>
    </Box>
  );
};
